module.exports = __webpack_public_path__ + "img/Avatar@2x.3fb70f5a.png";